import {Pipe, PipeTransform} from "@angular/core";
import * as _ from 'lodash';

@Pipe({
    name: 'formatEmpty'
})
export class FormatEmpty implements PipeTransform {
    transform(value: any, args) {
        return value ? value.toFixed(2) : '-';
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/format-empty.pipe.ts